import { render, staticRenderFns } from "./MenuGroupAddEdit.vue?vue&type=template&id=af6b1f8e"
import script from "./MenuGroupAddEdit.vue?vue&type=script&lang=js"
export * from "./MenuGroupAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports